import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Grid, Paper, Typography, TextField, Button, IconButton,
  InputAdornment, AppBar, Toolbar,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Turnstile } from 'react-turnstile';
import axios from '../../services/api';
import { MEIS_EDU_TOKEN } from '../../services/api';
import { loginSuccess, loginFailure } from '../../store/authSlice';
import { setClasses } from '../../store/classSlice';
import Spinner from '../Spinner/Spinner';
import MemoImg from '../Main/img/memo.png';
import LogoImg from '../Main/img/Telekom logo magenta 2022.png';
import LogoImgSmall from '../Main/img/Telekom logo magenta 2022.png';
import google_play from './splash/google_play.png';
import app_store from './splash/app_store.svg';

import splash_1 from './splash/splash_1.jpeg'; import splash_2 from './splash/splash_2.jpeg'; import splash_3 from './splash/splash_3.jpeg';
import splash_4 from './splash/splash_4.jpeg'; import splash_5 from './splash/splash_5.jpeg'; import splash_6 from './splash/splash_6.jpeg';
import splash_7 from './splash/splash_7.jpeg'; import splash_8 from './splash/splash_8.jpeg'; import splash_9 from './splash/splash_9.jpeg';
import splash_10 from './splash/splash_10.jpeg'; import splash_11 from './splash/splash_11.jpeg'; import splash_12 from './splash/splash_12.jpeg';
import splash_13 from './splash/splash_13.jpeg'; import splash_14 from './splash/splash_14.jpeg'; import splash_15 from './splash/splash_15.jpeg';
import splash_16 from './splash/splash_16.jpeg'; import splash_17 from './splash/splash_17.jpeg'; import splash_18 from './splash/splash_18.jpeg';
import splash_19 from './splash/splash_19.jpeg'; import splash_20 from './splash/splash_20.jpeg'; import splash_21 from './splash/splash_21.jpeg';
import splash_22 from './splash/splash_22.jpeg'; import splash_23 from './splash/splash_23.jpeg'; import splash_24 from './splash/splash_24.jpeg';
import splash_25 from './splash/splash_25.jpeg'; import splash_26 from './splash/splash_26.jpeg'; import splash_27 from './splash/splash_27.jpg';
import splash_28 from './splash/splash_28.jpg'; import splash_29 from './splash/splash_29.jpg'; import splash_30 from './splash/splash_30.jpg';

const splashImages = [
  splash_1, splash_2, splash_3, splash_4, splash_5, splash_6,
  splash_7, splash_8, splash_9, splash_10, splash_11, splash_12,
  splash_13, splash_14, splash_15, splash_16, splash_17, splash_18,
  splash_19, splash_20, splash_21, splash_22, splash_23, splash_24,
  splash_25, splash_26, splash_27, splash_28, splash_29, splash_30,
];

function chooseSpash() {
  const idx = new Date().getTime() % splashImages.length;
  return splashImages[idx] || null;
}

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const turnstileRef = useRef(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState('');
  const [turnstileKey, setTurnstileKey] = useState(0);
  const [badLogin, setBadLogin] = useState(false);
  const [badLoginMsg, setBadLoginMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [splash, setSplash] = useState(null);

  useEffect(() => {
    setSplash(chooseSpash());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const user = { username, pass: password, turnstileToken };
    axios.post('/api/login_captcha', user)
      .then((response) => {
        const data = response.data;
        setLoading(false);
        if (data.msg === '') {
          localStorage.setItem(MEIS_EDU_TOKEN, data.idToken);
          setBadLogin(false);
          setBadLoginMsg('');
          dispatch(loginSuccess(username));
          dispatch(setClasses(data.classes));
          if (data.is_admin) navigate('/admin');
          else navigate('/main');
        } else {
          setBadLogin(true);
          setBadLoginMsg(data.msg);
          setTurnstileToken('');
          setTurnstileKey((k) => k + 1);
          dispatch(loginFailure());
        }
      })
      .catch(() => {
        setLoading(false);
        setBadLogin(true);
        setBadLoginMsg('Došlo je do greške prilikom prijavljivanja');
        setTurnstileToken('');
        setTurnstileKey((k) => k + 1);
        dispatch(loginFailure());
      });
  };

  return (
    <div>
      <Grid container component="main"
        sx={{
          minHeight: isMobile ? 'calc(100vh - 40px)' : 'calc(100vh - 40px)',
          width: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: splash ? `url(${splash})` : 'none',
        }}
      >
        {loading && <Spinner />}

        <Paper elevation={3} sx={{ maxWidth: 420, textAlign: 'center' }}>
          <Typography component="h6" sx={{ mt: 2.5, fontStyle: 'italic' }}>
            Ministarstvo prosvjete, nauke i inovacija Crne Gore
          </Typography>
          <img src={MemoImg} alt="memo" />
          <Typography component="h1" variant="h5">
            Dnevnik
          </Typography>
          <div style={{ margin: 20, maxWidth: 340, marginLeft: 60, marginRight: 60 }}>
            <form onSubmit={handleSubmit} style={{ width: '100%', marginTop: 8 }}>
              {badLogin && (
                <div style={{ backgroundColor: 'red', color: 'white', borderRadius: 5 }}>
                  {badLoginMsg}
                </div>
              )}
              <TextField variant="outlined" margin="normal" fullWidth label="Korisničko ime"
                name="username" autoFocus placeholder="Unesite korisničko ime"
                onChange={(e) => setUsername(e.target.value)} />
              <TextField variant="outlined" margin="normal" fullWidth label="Šifra" name="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Unesite šifru"
                onChange={(e) => setPassword(e.target.value)} value={password}
                slotProps={{
                  inputLabel: { shrink: true },
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <div className="centered-container-row" style={{ marginTop: 20 }}>
                <Turnstile
                  key={turnstileKey}
                  ref={turnstileRef}
                  sitekey="0x4AAAAAABxMbFGUJwZ65WbC"
                  onVerify={(token) => setTurnstileToken(token)}
                  onExpire={() => setTurnstileToken('')}
                />
              </div>
              <Button type="submit" fullWidth variant="contained" color="primary"
                sx={{ mt: 3, mb: 2, height: 50 }} disabled={!turnstileToken}>
                Prijavi se
              </Button>
            </form>
          </div>
          <div className="centered-container-row" style={{ marginBottom: 20 }}>
            <div>
              <a href="https://play.google.com/store/apps/details?id=com.edume"
                target="_blank" rel="noopener noreferrer">
                <img src={google_play} width="141" height="42" alt="Google Play" />
              </a>
            </div>
            <div>
              <a href="https://apps.apple.com/us/app/e-dnevnik-me/id1506663957?ls=1"
                target="_blank" rel="noopener noreferrer">
                <img src={app_store} height="42" alt="App Store" />
              </a>
            </div>
          </div>
        </Paper>
      </Grid>

      {!isMobile ? (
        <div className="footer-fixed-login">
          <div style={{ marginLeft: 10 }}>Copyright &copy; Ministarstvo prosvjete, nauke i inovacija Crne Gore 2026</div>
          <div className="centered-container-row">
            <div style={{ marginRight: 10, marginTop: 3 }}>U saradnji sa </div>
            <a href="http://www.telekom.me" className="centered-container-row">
              <img src={LogoImg} style={{ marginRight: 10, height: 35 }} alt="Telekom" />
            </a>
          </div>
        </div>
      ) : (
        <div className="footer-fixed-login-mob">
          <div style={{ marginLeft: 10, fontSize: 10 }}>Copyright &copy; Ministarstvo prosvjete, nauke i inovacija Crne Gore 2026</div>
          <div className="centered-container-row">
            <div style={{ marginRight: 10, marginTop: 3, fontSize: 10 }}>U saradnji sa </div>
            <a href="http://www.telekom.me" className="centered-container-row">
              <img src={LogoImgSmall} style={{ marginRight: 10, height: 29 }} alt="Telekom" />
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
